import { render } from "./EditFamilyGroup.vue?vue&type=template&id=3068dedd&scoped=true"
import script from "./EditFamilyGroup.vue?vue&type=script&lang=js"
export * from "./EditFamilyGroup.vue?vue&type=script&lang=js"

import "./EditFamilyGroup.vue?vue&type=style&index=0&id=3068dedd&lang=scss"
import "./EditFamilyGroup.vue?vue&type=style&index=1&id=3068dedd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3068dedd"]])

export default __exports__